export default __webpack_public_path__ + "static/media/back-in-black.24a67862.jpg";